import { activityGroupService } from '@/bundles/ActivityGroup/factory/activityGroupServiceFactory';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';
import { IAddToGroupDto } from '@/bundles/ActivityGroup/dto';
import { ref } from '@vue/composition-api';

export function useActivityGroup() {
  const addToGroupLoading = ref(false);

  async function addToGroup(group: ActivityGroupType, payload: IAddToGroupDto) {
    addToGroupLoading.value = true;
    try {
      await activityGroupService.addToGroup(group, payload);
    } catch (error) {
      throw error;
    }
    finally {
      addToGroupLoading.value = false;
    }
  }

  const loadItemInGroupLoading = ref(false);
  const groupItems = ref<any[]>([]);
  async function loadItemInGroup(group: ActivityGroupType) {
    loadItemInGroupLoading.value = true;
    try {
      groupItems.value = (await activityGroupService.loadGroupItems(group, { take: 100 })).data;
    } catch (error) {
      throw error;
    } finally {
      loadItemInGroupLoading.value = false;
    }
  }

  async function deleteFromGroup(id: number) {
    await activityGroupService.deleteFromGroup(id);
  }

  async function bulkOrderUpdate(payload: { items: { id: number; order: number }[] }) {
    await activityGroupService.bulkOrderUpdate(payload);
  }

  return {
    addToGroup,
    addToGroupLoading,
    groupItems,
    loadItemInGroup,
    deleteFromGroup,
    bulkOrderUpdate,
  };
}
